import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import ArticleCard from "../../components/ArticleCard";
import Footer from "../../components/Footer";
import "./style.css";

const Home = () => {
  const [headline, setHeadline] = useState("");
  const [headlineUrl, setHeadlineUrl] = useState("");
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    fetch("https://homchang.in/headlines.php")
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          const latestHeadline = data[0];
  
          setHeadline(latestHeadline.title);
          setHeadlineUrl(latestHeadline.url || "#"); // Ensure it's never empty
  
          const formattedDate = new Date(latestHeadline.timestamp).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          });
          setCurrentDate(formattedDate);
        }
      })
      .catch((error) => console.error("Error fetching headline:", error));
  }, []);
  
  

  // Commented out the old articles_af logic This will return the latest headline
  /*
  useEffect(() => {
    fetch("https://homchang.in/articles_af.php")
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          const latestArticle = data.reduce((prev, curr) =>
            new Date(prev.timestamp) > new Date(curr.timestamp) ? prev : curr
          );

          setHeadline(latestArticle.Title);
          setHeadlineUrl(latestArticle.PageUrl);

          const formattedDate = new Date(latestArticle.timestamp).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          });
          setCurrentDate(formattedDate);
        }
      })
      .catch((error) => console.error("Error fetching headline:", error));
  }, []);
  */

  return (
    <>
      <Header headline={headline} date={`Published on ${currentDate}`} navigateTo={headlineUrl} />
      <div className="main-body">
        <div className="larger-section">
          <ArticleCard />
        </div>
        <div className="smaller-section">{/* Empty section */}</div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
